module.exports = __webpack_public_path__ + "static/media/dot_1AC4AD_a.664a07fa.svg";